import React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {ReactKeycloakProvider} from '@react-keycloak/web';

import './shared/styles/crema.less';
import {
  AppContextProvider,
  AppLayout,
  AppLocaleProvider,
  AppThemeProvider,
  AuthRoutes,
} from './@crema';
import configureStore from './redux/store';
import keycloak from './keycloak';
import {AbilityContext} from './configs/CASLContext';
import ability from './configs/Ability';

const store = configureStore();

const App = () => (
  <ReactKeycloakProvider authClient={keycloak}>
    <AbilityContext.Provider value={ability}>
      <AppContextProvider>
        <Provider store={store}>
          <AppThemeProvider>
            <AppLocaleProvider>
              <BrowserRouter>
                <AuthRoutes>
                  <AppLayout />
                </AuthRoutes>
              </BrowserRouter>
            </AppLocaleProvider>
          </AppThemeProvider>
        </Provider>
      </AppContextProvider>
    </AbilityContext.Provider>
  </ReactKeycloakProvider>
);

export default App;
